<template>
  <common-dialog ref="dialog" :title="title" width="1000px" @closed="onClosed">
    <el-table size="mini" :data="data" stripe border>
      <el-table-column prop="StudentNumber" label="学号"/>
      <el-table-column prop="CardNumber" label="卡号" min-width="100"/>
      <el-table-column prop="FullName" label="姓名"/>
      <el-table-column prop="ContactNumber1" label="电话一" min-width="110"/>
      <el-table-column prop="Call2" label="电话二" min-width="110"/>
      <el-table-column prop="ContactNumber3" label="电话三" min-width="110"/>
      <el-table-column prop="Amount" label="充值金额" />
      <el-table-column prop="RechargeTime" label="充值时间" min-width="140"/>
    </el-table>
    <template slot="footer">
      <el-button size="mini" type="primary" @click="onExport">导 出</el-button>
      <el-button size="mini" @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [detailsDialogMixin],
  components: { commonDialog },
  data() {
    return {
      api: require("@/api/consume/recharge").default,
      data: [],
      params: {},
      title: "导出 充值流水",
    };
  },
  methods: {
    getData(params) {
      this.params = this.$commonJs.obj.removeNullKey(params);
      this.$refs.dialog.isLoading = true;
      this.api.list(this.params).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) this.data = res.Data;
      });
    },
    onExport() {
      this.api.export(this.params);
    },
    onClosed() {
      this.data = [];
      this.params = {};
    },
  },
};
</script>